export default "__VITE_ASSET__8440f656__"